import api from './Api'

const route = '/drivers'

export default {
  get: params => api().get(`${route}`, { params }),
  view: params => api().get(`${route}/${params.id}`, { params }),
  viewDriverMov: params => api().get(`${route}/${params}`, { params }),
  post: (payload, params) => api().post(`${route}`, payload),
  put: (payload, params) => api().put(`${route}/${payload.id}`, payload),
  delete: payload => api().delete(`${route}/${payload.id}`),
  addImages: (id, payload) => api().post(`${route}/${id}/images`, payload, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  uploadDocumentFrontImage: (id, payload) => api().post(`${route}/${id}/document-front-image`, payload, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteDocumentFrontImage: (id) => api().delete(`${route}/${id}/document-front-image`),
  uploadDocumentBackImage: (id, payload) => api().post(`${route}/${id}/document-back-image`, payload, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteDocumentBackImage: (id) => api().delete(`${route}/${id}/document-back-image`)
  // enable: payload => api().put(`${route}/enable/${payload.id}`),
  // getStats: () => api().get(`${route}/stats`)
}
